







































































































import Vue from 'vue'
import { getConfig } from '../shared/config'
import { buildApiUrl } from '../shared/utils'
import InterfaceLanguageDropdown from './InterfaceLanguageDropdown.vue'

export default Vue.extend({
  components: {
    'interface-language-dropdown': InterfaceLanguageDropdown
  },

  data () {
    return {
      configLoaded: false,
      titleImageUrl: '',
      searchImageUrl: ''
    }
  },

  props: {
    indexName: String,
    smallFormat: Boolean,
  },

  async mounted () {
    const config = await getConfig()

    this.titleImageUrl = config.searchInstanceNameImage
      ? buildApiUrl(config.searchInstanceNameImage)
      : ''

    this.searchImageUrl = config.searchInstanceSearchImage
      ? buildApiUrl(config.searchInstanceSearchImage)
      : buildApiUrl('/img/search-home.png')

    this.configLoaded = true
  }
})
